// extracted by mini-css-extract-plugin
export default {"wrapper":"page-error_wrapper__ZE4be","logo":"page-error_logo__39DsD","title":"page-error_title__rR2DJ","message":"page-error_message__OaZNM","button":"page-error_button__5LrW4"};